<script setup lang="ts">
import { savedViewsRegistry } from '@/modules/saved-views/store/registry';
import { useNoReactive } from '@/composables/reactivity';

const props = defineProps<{
  name: string;
}>();

const name = useNoReactive(() => props.name, 'Saved views name should never change');

const savedViewsStore = savedViewsRegistry[name]();
</script>

<template>
  <v-container
    v-if="savedViewsStore.showTabs && savedViewsStore.savedViews.length > 0"
    class="py-0"
    data-test="tabs-container"
    fluid
  >
    <v-row class="mt-n2 mb-4" no-gutters>
      <v-tabs
        background-color="transparent"
        :color="savedViewsStore.isStateDirty ? 'orange' : 'primary'"
        data-test="v-tabs"
        :value="savedViewsStore.selectedIndex === null ? 0 : savedViewsStore.selectedIndex + 1"
        @change="(index) => savedViewsStore.selectView(savedViewsStore.savedViews[index - 1])"
      >
        <v-tab
          :class="{
            'dirty-view': savedViewsStore.isStateDirty && savedViewsStore.selectedIndex === null,
          }"
          style="display: none"
        >
          <!-- this tab is a hack to give the illusion that there are no tabs selected -->
        </v-tab>
        <v-tab
          v-for="(view, index) in savedViewsStore.savedViews"
          :key="index"
          :class="{
            'dirty-view': savedViewsStore.isStateDirty && savedViewsStore.selectedIndex === index,
          }"
          :data-test="`tab-${index}`"
        >
          {{ view.title }}
        </v-tab>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
::v-deep {
  .v-tab.dirty-view.v-tab--active {
    color: orange;
  }
}
</style>
